import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, CardHeader, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Chip } from '@mui/material';
import axios from 'src/utils/axios';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';

function ReceiptCustomer() {
    const { PhoneNumber } = useParams();
    const navigate = useNavigate();

    const [receiptCustomerData, setReceiptCustomerData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        getCustomerInformationFromPhoneNumber();
    }, [])

    const getCustomerInformationFromPhoneNumber = () => {
        axios.get(`GetCustomerInformationFromPhoneNumber/${PhoneNumber}`)
            .then((response) => {
                var customerData = response.data;
                setReceiptCustomerData(Array.isArray(customerData) ? customerData : []);
                setPage(0);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    const RouteReceiptCustomerDetailPage = (CustomerNo) => {
        navigate(`/ReceiptCustomerDetail/${CustomerNo}`);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 3 }}>
            <Card>
                <CardHeader
                    avatar={
                        <IconButton onClick={() => { handleGoBack(); }} size="small">
                            <ArrowBackIcon />
                        </IconButton>
                    }
                    title="Müşteri Bilgileri"
                />
                <Divider />
                <TableContainer>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Müşteri</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Semt</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Şehir</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Adres</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Telefon</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Kayıt Tarihi</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                Array.from(new Array(3)).map((_, index) => (
                                    <TableRow key={index}>
                                        {Array.from(new Array(6)).map((_, cellIndex) => (
                                            <TableCell key={cellIndex} colSpan={1}>
                                                <Skeleton animation="pulse" variant="text" width={150} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                receiptCustomerData.length > 0 && receiptCustomerData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customer, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Chip
                                                label={customer.ADI + ' ' + customer.SOYADI}
                                                size="small"
                                                variant="outlined"
                                                clickable
                                                onClick={() => { RouteReceiptCustomerDetailPage(customer.MUSTERI_NO); }}
                                            />
                                        </TableCell>
                                        <TableCell>{customer.ILCE}</TableCell>
                                        <TableCell>{customer.IL}</TableCell>
                                        <TableCell>{customer.ADRES}</TableCell>
                                        <TableCell>
                                            {(customer.TEL1 ? customer.TEL1 : '') + (customer.TEL2 ? ' - ' + customer.TEL2 : '')}
                                        </TableCell>
                                        <TableCell>{moment(customer.KAYIT_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={receiptCustomerData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
        </Container>
    );
}

export default ReceiptCustomer
